"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var input_1 = require("../../input");
var layout_1 = require("../../layout");
var icons_1 = require("../../../icons");
var constants_1 = require("../../input/Button/constants");
var styles = {
    mainButton: {
        default: react_1.css({
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: "1px solid " + style_1.DesignSystemThemeColor.Primary.DARK_2,
        }),
        secondary: react_1.css({
            borderRightColor: style_1.DesignSystemThemeColor.Gray.LIGHT_2,
        }),
    },
    dropdownButton: react_1.css({
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeftWidth: 0,
    }),
};
var ICON_SIZE_MAP = {
    small: 16,
    default: 16,
    large: 20,
};
// Padding is 1 less than it should be to account for 1px border
var SPLIT_PADDING_MAP = {
    small: 5,
    default: 9,
    large: 11,
};
var SplitButton = function (_a) {
    var onSplitClick = _a.onSplitClick, props = __rest(_a, ["onSplitClick"]);
    return (react_1.jsx(layout_1.Flex, null,
        react_1.jsx(input_1.Button, __assign({ css: [
                styles.mainButton.default,
                props.variant === 'secondary' ? styles.mainButton.secondary : undefined,
            ] }, props)),
        react_1.jsx(input_1.Button, { variant: props.variant, destructive: props.destructive, size: props.size, onClick: onSplitClick, css: [
                styles.dropdownButton,
                { padding: SPLIT_PADDING_MAP[constants_1.SIZE_TO_INTERNAL_SIZE[props.size || 'default']] },
            ] },
            react_1.jsx(icons_1.ChevronDown, { size: ICON_SIZE_MAP[constants_1.SIZE_TO_INTERNAL_SIZE[props.size || 'default']] }))));
};
exports.default = SplitButton;
